// UXP properties not intrinsically handled by the SDK CAPTURE_AND_PROCESS_FRAME options.

import { createSlice } from "@reduxjs/toolkit";

export const autoCaptureOptionsSlice = createSlice({
  name: "autoCaptureOptions",
  initialState: {
    value: {
      timeoutSec: 20,
      showCancel: false,
    },
  },
  reducers: {
    update: (state, action) => {
      state.value.timeoutSec = action.payload.timeoutSec;
      state.value.showCancel = action.payload.showCancel;
    },
  },
});

export const { update } = autoCaptureOptionsSlice.actions;

export default autoCaptureOptionsSlice.reducer;
